export default __webpack_public_path__ + "static/Aeonik-Thin-5f053c6b6c30034467b1bb481dc1ecbc.otf";